import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axios from 'axios';
import CONFIG from 'app/config';
import { query, mutation } from "../../../../graphql/booking/items_graphql";
import { mutation as mutationUpload } from "../../../../graphql/upload_graphql";
import { query as queryType } from "../../../../graphql/settings/booking_item_types_graphql";
import uploadSvc from "../../../../services/upload";
import randomString from "../../../../services/randomString";
import { showMessage } from "app/store/fuse/messageSlice";

export const checkBookingItemExists =
    (params) => async (dispatch) => {
        const response = await axios.post(CONFIG.API + "/api/", {
            query: query.checkBookingItemExists,
            variables: params,
        });

        if (response.data.data.checkBookingItemExists.length) {
            return false;
        } else {
            return true;
        }

    };

export const getItemByID = createAsyncThunk(
    "bookingApp/bookingItemsModal/getItemByID",
    async (params) => {
        const response = await axios.post(CONFIG.API + "/api/", {
            query: query.getItemByID,
            variables: {
                itemId: params.id,
            },
        });

        if (response.data.data.bookingItemById) {
            const data = response.data.data.bookingItemById;

            return data === undefined ? null : data;
        }
    }
);


const saveImages = (itemData) => {

    return new Promise(async (resolve, reject) => {

        if (itemData.images.length) {

            var newImages = [];

            itemData.images.map(async (image, index) => {

                if (image.status === "new") {
                    newImages.push({
                        index: index,
                        image: image
                    })
                } else {
                    if (itemData.featuredImageId == image.fileId) {
                        itemData.featuredImagePath = image.path;
                    }
                }

                console.log(itemData, image)

            });

            if (newImages.length) {

                newImages.map(async (image, index) => {

                    await uploadSvc({
                        file: image.image.file,
                        destination_file_name: "booking/item/item-" + randomString() + "-" + (image.image.file ? image.image.file.name : image.image.fileName)
                    }).then(async (result) => {

                        if (result.status === 200 && result.data.status === "success") {

                            var uploadData = result.data.uploadData
                            uploadData['module'] = 'booking-item';
                            uploadData['file_id'] = image.image.id;

                            const response = await axios.post(CONFIG.API + "/api/", {
                                query: mutationUpload.create,
                                variables: {
                                    data: JSON.stringify(uploadData),
                                },
                            });

                            if (response.data.data.createUpload.status == "success") {
                                var upload = response.data.data.createUpload.upload;

                                if (itemData.featuredImageId == image.image.id) {
                                    itemData.featuredImagePath = upload.path;
                                }

                                itemData.images[image.index].upload_id = upload.id;
                                itemData.images[image.index].file_name = upload.fileName;
                                itemData.images[image.index].file_id = upload.fileId;
                                itemData.images[image.index].file_type = upload.fileType;
                                itemData.images[image.index].path = upload.path;
                                itemData.images[image.index].module = upload.module;
                                // itemData.images[image.index].url = "";



                            }
                        }

                        if (newImages.length == (index + 1)) {
                            resolve(itemData);
                        }


                    });

                });

            } else {
                resolve(itemData)
            }


        } else {
            resolve(itemData);

        }

    });

}

export const saveItem = createAsyncThunk(
    "bookingApp/bookingItemsModal/saveItem",
    async (itemData, { dispatch, getState }) => {

        itemData.publicRate = itemData.publicRate ? parseFloat(itemData.publicRate) : 0;
        itemData.cmiRate = itemData.cmiRate ? parseFloat(itemData.cmiRate) : 0;

        await saveImages(itemData).then(async (itemData) => {

            if (itemData.id) {
                const response = await axios.post(CONFIG.API + "/api/", {
                    query: mutation.edit,
                    variables: {
                        data: JSON.stringify(itemData),
                        id: itemData.id,
                    },
                });

                console.log('GGGGG', response);

                if (response.data.data.editBookingItems.status != 'error') {
                    dispatch(
                        showMessage({
                            message: "Item has been successfully updated.",
                            autoHideDuration: 5000, //ms
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "right",
                            },
                            variant: "success",
                        })
                    );
                    if (!isMain) return;
                    setSaveStatus(true);
                } else {
                    dispatch(
                        showMessage({
                            message: "Something went wrong. Please try again later.",
                            autoHideDuration: 5000, //ms
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "right",
                            },
                            variant: "error",
                        })
                    );
                    if (!isMain) return;
                    setSaveStatus(false);
                }

            } else {
                const response = await axios.post(CONFIG.API + "/api/", {
                    query: mutation.create,
                    variables: { data: JSON.stringify(itemData) },
                });

                if (response.data.data.createBookingItems.status != 'error') {
                    dispatch(
                        showMessage({
                            message: "Item has been successfully saved.",
                            autoHideDuration: 5000, //ms
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "right",
                            },
                            variant: "success",
                        })
                    );
                } else {
                    dispatch(
                        showMessage({
                            message: "Something went wrong. Please try again later. " + response.data.data.createItems.message,
                            autoHideDuration: 5000, //ms
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "right",
                            },
                            variant: "error",
                        })
                    );
                }
            }

        });

    }
);

export const getTypes = createAsyncThunk('bookingApp/bookingItemsModal/getTypes', async () => {
    const response = await axios.post(CONFIG.API + "/api/", {
        query: queryType.list
    });
    const data = response.data.data.bookingItemTypesList;
    return data;
});

const bookingItemsAdapter = createEntityAdapter({});

export const { selectAll: selectTypes, selectById: selectTypeById } =
    bookingItemsAdapter.getSelectors((state) => state.bookingApp.bookingItemsModal);

const bookingItemsModalSlice = createSlice({
    name: 'bookingApp/bookingItemsModal',
    initialState: bookingItemsAdapter.getInitialState({
        searchText: '',
        typeText: '',
    }),
    reducers: {},
    extraReducers: {
        [getItemByID.fulfilled]: (state, action) => action.payload,
        [saveItem.fulfilled]: (state, action) => action.payload,
        [getTypes.fulfilled]: bookingItemsAdapter.setAll,
    },
});


export default bookingItemsModalSlice.reducer;
